import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { EventAggregator } from 'aurelia-event-aggregator';
import { AssignedProjectService } from 'pages/daiatari/assigned-projects/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, createButton } from 'resources/utility';
import toastr from 'toastr';

@inject(AssignedProjectService, DialogService, EventAggregator, Router)
export class AssignedProject {
    constructor(assignedProjectService, dialogService, ea, router) {
        this.ea = ea;
        this.router = router;
        this.assignedProjectService = assignedProjectService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'description', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { dataField: 'statusName', caption: 'Status' },
            { caption: 'Actions', cellTemplate: (container, options) => {
                const deleteButton = createButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete });
                deleteButton.style.marginRight = '20px';
                const linkButton = createButton({ container, containerOptions: options, style: 'primary', label: 'Link to Quotes', action: () => this.router.navigateToRoute('link-assigned-project', { id: options.data.id }) });

                const div = document.createElement('div');
                div.appendChild(deleteButton);
                div.appendChild(linkButton);
                container.append(div);
            }, allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('assigned-projects:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (assignedProject) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.assignedProjectService.delete(assignedProject.id);
                this.grid.refresh();
                toastr.success('Assigned project was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.assignedProjectService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.assignedProjectService.editor, model: { id: data.id } });
    };
}